import dayjs, { TIMEZONE } from './dayjs'
import { TeacherFields } from '../redux/types'

export const mapValue = (
    value: number,
    fromLow: number,
    fromHigh: number,
    toLow: number,
    toHigh: number
): number =>
    Math.round(
        value < fromLow
            ? toLow
            : value > fromHigh
              ? toHigh
              : ((value - fromLow) * (toHigh - toLow)) / (fromHigh - fromLow) +
                toLow
    )
export const getError = (error: any): string =>
    error instanceof Error ? error.message : String(error)

export const getInitials = (text?: string): string => {
    if (!text) return ''
    let temp = text
    let newText = ''
    temp.split('').forEach((el, i) => {
        if (el === '(' && i + 1 < text.length && text.charAt(i) !== ' ') {
            newText = newText + ' ' + el + ' '
        } else if (el === ')' && i - 1 > 0 && text.charAt(i - 1) !== ' ') {
            newText = newText + ' ' + el
        } else {
            newText = newText + el
        }
    })
    let r = newText
        .split(' ')
        .map((n) => n[0])
        .join('')
    return r
}

export const allFieldsDefined = (
    obj?: Object,
    exceptKeys?: string[]
): boolean => {
    if (obj === undefined) {
        return false
    }
    return Object.entries(obj).every(([k, v]) => {
        if (exceptKeys !== undefined && exceptKeys.includes(k)) {
            return true
        }
        return v !== undefined
    })
}

export const someFieldsDefined = (
    obj?: Object,
    exceptKeys?: string[]
): boolean => {
    if (obj === undefined) {
        return false
    }
    return Object.entries(obj).some(([k, v]) => {
        if (exceptKeys !== undefined && exceptKeys.includes(k)) {
            return true
        }
        return v !== undefined
    })
}

export const getFullname = (fields: TeacherFields) => {
    return `${fields.preferredName?.value || fields.firstName?.value} ${
        fields.lastName?.value
    }`
}

export const isDocExpired = (docDate?: string) => {
    if (!docDate) return false
    return dayjs.tz().isAfter(dayjs.tz(docDate, 'DD-MM-YYYY', TIMEZONE), 'd')
}

export const camelCaseToTitleCase = (input: string): string => {
    return (
        input
            // Insert a space before all caps
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize the first letter of each word
            .replace(/\b\w/g, (char) => char.toUpperCase())
    )
}

export const getUserNames = (
    firstName?: string,
    lastName?: string,
    firstNameActual?: string | null
): { firstName: string; lastName: string; preferredName: string } => {
    if (!!firstNameActual) {
        return {
            firstName: firstNameActual,
            lastName: lastName || '',
            preferredName: firstName || '',
        }
    }
    return {
        firstName: firstName || '',
        lastName: lastName || '',
        preferredName: firstName || '',
    }
}

export const sToMs = (s: number) => s * 1000
export const mToMs = (s: number) => s * 1000 * 60

export const shuffleArray = <T>(arr: T[]) => {
    return arr.sort(() => Math.random() - 0.5)
}

export const selectN = <T>(list: T[], n: number, alwaysShuffle?: boolean) => {
    if (n < 1 || list.length === 0) {
        return []
    }
    if (list.length <= n) {
        if (alwaysShuffle) {
            return shuffleArray(list)
        }
        return list
    }
    return shuffleArray(list).slice(0, n)
}
